import React from 'react';
import { useParams } from 'react-router-dom';
import ParticipantList from './ParticipantList';
import BackButton from '../BackButton';
import { langType, withLang } from '../../i18n';
import useTitle from '../../hooks/useTitle';

const SurveyUsers = ({ translate }) => {
  const { surveyId } = useParams();
  useTitle(translate('manageSurveys.participants'));
  return (
    <div className="page-container">
      <BackButton />
      <ParticipantList surveyId={surveyId} />
    </div>
  );
};

SurveyUsers.propTypes = {
  translate: langType.translate.isRequired
};

export default withLang(SurveyUsers);
